import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {bulkDownloadStatus, downloadState, downloadSync} from 'utils/mediafire';
import {downloadMinimized} from 'interface/hooks/effects/transfers';
import {selectors} from 'store/slices/transfers';
import {slices} from 'store';

export function useDownloader() {
  const bulk = useSelector(selectors.getDownloadBulk);
  const items = useSelector(selectors.getDownloadItems);
  const view = useSelector(selectors.getDownloadView);
  const status = downloadState(items);

  const dispatch = useDispatch();
  const stopProp = useCallback((e) => e.stopPropagation(), []);
  const minimize = useCallback(downloadMinimized(dispatch, true), []);
  const maximize = useCallback(downloadMinimized(dispatch, false), []);
  const exit = useCallback(() => {
    dispatch(slices.transfers.actions.downloadClose());
  }, []);

  // Sync bulk downloads
  useEffect(() => {
    const completed = [];
    const update = () => {
      const promises = [];
      bulk.forEach(download => {
        if (!completed.includes(download.statusKey)) {
          promises.push(bulkDownloadStatus(download.statusKey));
        }
      });
      Promise.all(promises).then(res => {
        const items = res.map((status, i) => {
          const id = bulk[i].statusKey;
          const name = bulk[i].fileName;
          if (status.state === 'complete')
            completed.push(id);
          const state = status.state;
          const total = status?.bytes?.total || 0;
          const bytes = total - (status?.summary?.bytesToSend || 0);
          return {id, name, state, total, bytes};
        });
        downloadSync(dispatch, items);
      })
    };
    update();
    const interval = setInterval(update, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [bulk]);

  return {
    bulk,
    view,
    items,
    status,
    minimize,
    maximize,
    stopProp,
    exit,
  };
}
